<template>
  <div class="template w-full">
    <lead-create />
  </div>
</template>

<script>

import LeadCreate from '../../components/leads/create.vue'

export default {

  components: {
    LeadCreate
  }
}

</script>

<style>
    .footer {
        background-color: rgba(248, 248, 248, 0.9);
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
</style>
